// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1HI7i","insightsList":"newBusinessInsightsMenu_insightsList__1kZC0","active":"newBusinessInsightsMenu_active__3skwI"};